module.exports = __webpack_public_path__ + "static/paczki_osobno_gold@2x-103da9fb5acc462c573706dc7b1d3191.png";